import dayjs from "dayjs";

export const timeStampToDate = (created_at?: string | Date | null) => {
  if (!created_at) return "";

  try {
    // 경과한 시간 계산 (1초 = 1000)
    const timeElapsed = Math.floor(
      (Date.now() - new Date(created_at).getTime()) / 1000
    );

    if (timeElapsed < 0) {
      return "방금 전";
    } else if (timeElapsed < 60) {
      return `방금 전`;
    } else if (timeElapsed < 60 * 60) {
      const minutes = Math.floor(timeElapsed / 60);
      return `${minutes}분 전`;
    } else if (timeElapsed < 60 * 60 * 24) {
      const hours = Math.floor(timeElapsed / (60 * 60));
      return `${hours}시간 전`;
    } else if (timeElapsed < 60 * 60 * 24 * 7) {
      const days = Math.floor(timeElapsed / (60 * 60 * 24));
      return `${days}일 전`;
    } else {
      // 일주일 이상 지난 아이템에 대해서는 YYYY-MM-DD로 표기
      return new Date(created_at).toISOString().slice(0, 10);
    }
  } catch (error) {
    console.error("날짜 변환 중 오류 발생:", error);
    return "";
  }
};

/** 시간에 따른 포멧 (방금, n분전, n시간전) */
export const formatCreatedAt = (createdAt: string) => {
  const created = dayjs(createdAt);
  const now = dayjs();
  const diffInSeconds = now.diff(created, "second");
  const diffInHours = now.diff(created, "hour");

  if (diffInHours >= 24) {
    return created.format("YYYY-MM-DD HH:mm"); // 하루 이상 → 일반 날짜 포맷
  }

  if (diffInSeconds < 30) {
    return "방금";
  }

  return created.fromNow(); // "몇 분 전", "몇 시간 전" 등
};
